import React from "react";
import { Box } from "@mui/material";
import Navbar, { NavProps } from "../../Navbar";
import { ACCENT } from "../BusinessOnboard.constant";

interface IOnboardLayoutProps {
  /** Kept for API compatibility; no longer rendered (flat layout). */
  progress?: number;
  children: React.ReactNode;
  pageType?: NavProps["pageType"] | "MANUAL_ONBOARD"
}

/**
 * Full-viewport onboarding shell: fixed Navbar + a centered, flat content
 * column (no card background/shadow/padding) sitting on the page background.
 */
export const OnboardLayout: React.FC<IOnboardLayoutProps> = ({
  children, pageType
}) => {
  return (
    <>
      {pageType !== "MANUAL_ONBOARD" && <Navbar
        pageType="SIGNUP"
        accentColor={ACCENT.main}
        accentHoverColor={ACCENT.dark}
      />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 2, md: 3 },
          ...(pageType === "MANUAL_ONBOARD" ? {
            pt: { xs: 1, md: 2 },
          } : {
            pt: { xs: 10, md: 11 },
            minHeight: "100vh",
          }),
          pb: 3,
          boxSizing: "border-box",

        }}
      >
        {/* Flat container — no card background/shadow/padding; content sits
            directly on the page. */}
        <Box sx={{ width: "100%", maxWidth: 620 }}>{children}</Box>
      </Box>
    </>
  );
};
